export default "__VITE_ASSET__BRiC0GBR__"